module.exports = __webpack_public_path__ + "static/media/call-feedback-technical-issues-grey.012182b7.svg";